const faqs = document.querySelectorAll(".faq");

function removeAll() {
  faqs.forEach((el) => el.classList.remove("active"));
}

faqs.forEach((element) => {
  element.addEventListener("click", () => {
    if (element.classList.contains("active")) {
      element.classList.remove("active");
      return;
    }

    removeAll();
    element.classList.toggle("active");
  });
});
